import React, { useState, useEffect } from 'react'
import Year from './Year.js';
import Map from './Map.js';
import ProgressBar from './ProgressBar.js';
import ProgressDots from './ProgressDots.js';
import './style.css';

function App() {
  const [currentYear, setCurrentYear] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [years, setYears] = useState(null);
  let timelineData = window.timelineData || {};
  let timelineRecentAsOf = window.timelineRecentAsOf || 'December 31';
  const mostRecentYear = new Date().getFullYear();

  useEffect(() => {
    // Initialize.
    const firstYear = Object.keys(timelineData)[Object.keys(timelineData).length - 1];
    setCurrentYear(firstYear);
    setYears(Object.keys(timelineData));
  }, []);

  const handlePrev = (e) => {
    const timelineKeys = Object.keys(timelineData);
    console.log(timelineKeys);
    const currentIndex = timelineKeys.indexOf(currentYear);
    let newIndex = currentIndex - 1;

    if (newIndex < 0) {
      newIndex = timelineKeys.length - 1;
    }

    const newKey = timelineKeys[newIndex].toString();

    setCurrentYear(newKey);
  }

  const handleNext = (e) => {
    const timelineKeys = Object.keys(timelineData);
    const currentIndex = timelineKeys.indexOf(currentYear);
    let newIndex = currentIndex + 1;

    if (newIndex >= timelineKeys.length) {
      newIndex = 0;
    }

    const newKey = timelineKeys[newIndex].toString();

    setCurrentYear(newKey);
  }

  const handleCurrentItem = (e) => {
    setCurrentItem(e);
  }

  const handleUpdateCard = (year, slug) => {
    setCurrentItem(slug);
    setCurrentYear(year);
  }

  return (

    <div className="ma-timeline-react-wrapper">
      <div className="row">
        <div className="col-map col-12 col-md-8">
          <Map
            currentYear={currentYear}
            currentItem={currentItem}
            timelineData={timelineData}
            updateCard={handleUpdateCard}
          />
          <ProgressDots
            currentYear={currentYear}
            years={years}
            setCurrentYear={setCurrentYear}
          />
        </div>
        <div className="col-timeline col-12 col-md-4">
          <button className="slide-prev" onClick={handlePrev}>Prev</button>
          <div className="col-timeline-inner">
            <ProgressBar
              currentYear={currentYear}
              years={years}
            />
            <div className="col-timeline-years">
              <div className="accordion" id="ma-accordion">
                {Object.keys(timelineData).map((key, index) => (
                  <Year
                    name={key}
                    key={parseInt(key)}
                    locations={timelineData[key].items}
                    aum={timelineData[key].aum}
                    isCurrent={(currentYear === key) ? true : false }
                    isMostRecent={parseInt(mostRecentYear) === parseInt(key) ? true : false }
                    mostRecentAsOf={timelineRecentAsOf}
                    currentItem={currentItem}
                    updateCurentItem={handleCurrentItem}
                  />
                ))}
              </div>
            </div>
          </div>
          <button className="slide-next" onClick={handleNext}>Next</button>
        </div>
      </div>
    </div>
  );
}

export default App;
